import { useState, useEffect } from "react";
import { Frame, Loading, Header, ValidaUid } from "../components";
import { useNavigate } from "react-router-dom";
import { db, auth } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Button, Form } from "react-bootstrap";

const Form1 = () => {
  const [dados, setDados] = useState({});
  const [turno, setTurno] = useState("manha");
  const [modalidade, setModalidade] = useState("1");
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const setData = async () => {
    await setDoc(
      doc(db, "cangucu2026", uid),
      { ...dados, turno: turno, modalidade: modalidade },
      { merge: true },
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    setData().then(() => navigate("../aceite"));
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "cangucu2026", uid));

      const data = qry.data();

      if (!data?.status) {
        setLoading(false);
        if (data?.turno) setTurno(data?.turno);
        if (data?.modalidade) setModalidade(data?.modalidade);
        setDados(data);
      } else {
        navigate("../home");
      }
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      {!loading && (
        <Frame
          body={
            <Form className="text-start p-3" onSubmit={handleSubmit}>
              <h6>TURNO</h6>
              <Form.Check
                type="radio"
                label="Manhã - Saída às 06:00"
                name="turno"
                value="manha"
                className="mt-2"
                checked={turno === "manha"}
                onChange={(e) => setTurno(e.target.value)}
              />

              <Form.Check
                type="radio"
                label="Noite - Saída às 17:00 (Condicionado a demanda)"
                name="turno"
                value="noite"
                className="mt-2"
                checked={turno === "noite"}
                onChange={(e) => setTurno(e.target.value)}
              />

              <hr />

              <h6>MODALIDADE</h6>

              <Form.Check
                type="radio"
                label="Fixo: R$ 650,00 mensais - 44 créditos para a utilização dentro do mês."
                name="modalidade"
                value="1"
                className="mt-2"
                checked={modalidade === "1"}
                onChange={(e) => setModalidade(e.target.value)}
              />

              <Form.Check
                type="radio"
                label="Variável: mínimo de R$ 325,00 - Compra mínima de 22 créditos para utilização dentro do mês."
                name="modalidade"
                value="2"
                className="mt-2"
                checked={modalidade === "2"}
                onChange={(e) => setModalidade(e.target.value)}
              />
              <div className="d-grid mt-4">
                <Button variant="primary" type="submit">
                  ENVIAR
                </Button>
              </div>
            </Form>
          }
          title="Dados Cadastrais"
        />
      )}
    </>
  );
};

export default Form1;
